export default "__VITE_ASSET__DBi04i$w__"